// extracted by mini-css-extract-plugin
export var divider = "_d6-7";
export var itemsToggle = "_d6-8";
export var mergeModal = "_d6-1";
export var optionCard = "_d6-4";
export var radioGroup = "_d6-6";
export var radioOption = "_d6-0";
export var selected = "_d6-5";
export var shipmentOptions = "_d6-2";
export var tableOptions = "_d6-3";